import axios from "axios";
import { isTestEndpoint } from "./helpers/isDev";

let baseUrl;
let apiUrl;
let signupUrl;
let coverageUrl;
let exApiUrl = window.i3.siteExApiURL;

if(isTestEndpoint()) {
    baseUrl = window.i3.siteURL;
    apiUrl = window.i3.siteApiURL+'-testing/';
    signupUrl = window.i3.signupApiURL;
    coverageUrl = window.i3.coverageApiURL;
} else if(false && window.location.host.indexOf('localhost') !== -1) {
    baseUrl = 'http://i3-broadband.local/';
    apiUrl = baseUrl + '/api/buyflow/';
} else {
    baseUrl = window.i3.siteURL;
    apiUrl = window.i3.siteApiURL+'/';
    signupUrl = window.i3.signupApiURL;
    coverageUrl = window.i3.coverageApiURL;
}

const unauthenticatedApi = axios.create({
    baseURL: apiUrl,
});

const coverageApi = axios.create({
    baseURL: coverageUrl,
    
    headers: {
        'Content-Type': 'application/json',   
        'Authorization': `Bearer ${process.env.REACT_APP_COVERAGE_API_TOKEN}`      
    }
});
const signupApi = axios.create({
    baseURL: signupUrl,
    
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_SIGNUP_API_TOKEN}`
    }
});

const ossApi = axios.create({
    baseURL: exApiUrl+'i3-oss-api/',
    
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_I3_OSS_API_TOKEN}`
    }
});

export {
    baseUrl,
    apiUrl,    
    signupApi,
    unauthenticatedApi,
    coverageApi,
    ossApi,
    
};
